import React, { useEffect, useState } from 'react';
import { getClassName } from '@onsolve/utils.get-class-name';
import { Button, LoadingSpinner, Radio, RadioGroup, TextArea, Typography } from '@onsolve/onsolve-ui-components';
import { t } from '@lingui/macro';
import styles from './ShowResponses.module.scss';
import StickyButtonBar from './StickyButtonBar';
const ShowResponses = ({ response, handleResponseChange, isLoading }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'ShowResponses-page',
        styles,
    });
    const [selectedResponseOption, setSelectedResponseOption] = useState(undefined);
    const [selectedResponseOptionFollowUp, setSelectedResponseOptionFollowUp] = useState(undefined);
    useEffect(() => {
        if (response?.['response']) {
            setSelectedResponseOption(response?.responseOptions?.find((m) => m.id === response?.['response']));
            setSelectedResponseOptionFollowUp(response?.responseOptions?.find((m) => m.id === response?.['response'])?.followUp);
        }
    }, [response]);
    return (<>
            {selectedResponseOptionFollowUp?.length > 0 && (<div className={`${rootClass} mb-5`}>
                    {selectedResponseOptionFollowUp?.map((question) => {
                return (<>
                                <div className={`mb-3 ${getChildClass('response-question')}`}>
                                    <div className={getChildClass('response-index')}>{question['serialNumber']}</div>
                                    <Typography variant={'p16'} className="mb-0 pl-3">
                                        {question?.verbiage?.text[0]?.value}
                                    </Typography>
                                </div>

                                {question?.choice && question?.choice?.length > 0 && (<RadioGroup value={question['response']} onChange={null} className={'ml-1'} name={'responseOption'}>
                                        {question?.choice?.map((choice) => (<Radio className="mb-2" key={choice.id} label={choice?.verbiage?.text[0]?.value} value={choice.id} type={'radio'} disabled={true}/>))}
                                    </RadioGroup>)}

                                {question?.choice && question?.choice?.length === 0 && (<TextArea className={`${getChildClass('response-textarea')} mb-2`} rows={3} label={t `Write your answer.`} value={question['response']} onChange={null} placeholder={t `Enter your answer`} disabled={true}/>)}
                            </>);
            })}
                </div>)}

            {selectedResponseOptionFollowUp?.length === 0 && (<div className={`${rootClass} mb-5`}>
                    <Typography variant={'p18'} className="m-0">
                        {t `Alert Reply`}
                    </Typography>
                    {isLoading ? (<div className="mx-auto text-center my-4">
                            <LoadingSpinner logoType={'newLogo'} size="xxl"/>
                        </div>) : (<div className={getChildClass('responseOption-wrapper')}>
                            <Typography variant={'p16'} className="mt-2 mb-4">
                                {t `Do you want to save your response?`}
                            </Typography>

                            {selectedResponseOption && (<div className="my-4">
                                    <RadioGroup value={response?.['response']} onChange={null} className={'ml-1'} name={'responseOption'}>
                                        {response.responseOptions?.map((item, index) => (<Radio className="mb-2" key={item?.id} label={item?.verbiage?.text[0]?.value} value={item?.id} type={'radio'} disabled={true}/>))}
                                    </RadioGroup>
                                </div>)}
                        </div>)}
                </div>)}
            {response?.settings?.allowResponseChange && (<StickyButtonBar rightContent={<Button color="primary" variant="raised" className="px-4" onClick={handleResponseChange} disabled={false}>
                            {t `Change Response`}
                        </Button>}/>)}
        </>);
};
export default ShowResponses;
